// components.application.integrations.noIntegrations

export const NO_INTEGRATIONS = {
  title: 'No integrations found',
  cloudDescription: 'You dont have any cloud integrations connected to your organization.',
  description: 'You dont have any integrations connected to your organization.',
  connect: 'Connect Integration'
};
